// src/components/GradientColorPickerComp.js
import React, { useState } from "react";
import ColorPicker from "react-best-gradient-color-picker";

function GradientColorPickerComp(props) {
  const [color, setColor] = useState("rgba(0,128,128,1)");

  const handleDegrees = (val) => {
    let num = parseInt(val);
    let nans = isNaN(num) ? 0 : num;
    let min = Math.max(nans, 0);
    let max = Math.min(min, 360);
    const remaining = val.split(/,(.+)/)[1];
    if (val.includes("linear")) {
      props.handleChangeColor(`linear-gradient(${max}deg, ${remaining}`);
    } else if (val.includes("radial")) {
      props.handleChangeColor(`radial-gradient(${max}deg, ${remaining}`);
    } else {
      props.handleChangeColor(val);
    }
    setColor(val);
  };

  return (
    <ColorPicker
      sx={{ bgColor: "#fff" }}
      width={240}
      value={color}
      onChange={(e) => handleDegrees(e)}
      hideAdvancedSliders={true}
      hideColorGuide={false}
      hidePresets={false}
      isGradient={true}
    />
  );
}

export default GradientColorPickerComp;
